import { useContent } from "../ContentContext";
import DarkFooter from "../sections/DarkFooter";

const Disclosure = () => {
  const content = useContent();

  return (
    <div className="bg-dark text-light h-screen flex flex-col">

      {/* Homepage Section */}
      <section className="relative h-full text-center bg-light text-white flex-grow">
        {/* Video Background */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/videos/homepage.png"
        >
          <source src="/videos/homepage.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        {/* Overlay Layer */}
        <div className="absolute inset-0 bg-gradient-to-b from-dark/70 via-dark/70 to-dark"></div>

        {/* Overlay Content */}
        <div className="p-4 max-w-4xl mx-auto flex flex-col items-center justify-center h-full">
          <div className={`relative p-8  `}>
            {/* Top-Left Border */}
            <div
              className={`absolute top-0 left-0 w-12 h-12 border-t-4 border-l-4 border-primary`}
            ></div>

            {/* Bottom-Right Border */}
            <div
              className={`absolute bottom-0 right-0 w-12 h-12 border-b-4 border-r-4 border-primary`}>
            </div>

            {/* Content */}
            <p className="text-[10px] sm:text-[16px] font-garet text-light">
              {content.disclosure.body}
            </p>
            <br></br>
            <p className="text-[10px] sm:text-[16px] font-garet text-light">
              {content.disclosure.footer}
            </p>
          </div>
        </div>
      </section>

     
      {DarkFooter()}
      
      
    </div>
  );
};

export default Disclosure;